export default [
  {
    path: "/call-satisfaction",
    name: "call-satisfaction",
    component: () => import("@/views/callSatisfaction/List.vue"),
    meta: {
      pageTitle: "breadcrumb.callSatisfaction",
      navActiveLink: "call-satisfaction",
      resource: "report-call-satisfaction",
      action: "read",
      breadcrumb: [
        {
          text: "breadcrumb.callSatisfaction",
          active: true,
        },
      ],
    },
  },
];
